import { trackEvent } from '../util/analytics'

up.compiler('[data-career-dialog]', () => {
  trackEvent('careerDialog.show')
})
